import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Args {
  roomId: string;
}

export interface RawResult {
  createFamilyKey: string;
}

export const createFamilyKey = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      roomId: args.roomId
    },
    update(_proxy, data): string {
      return data.data!.createFamilyKey;
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
